import React from 'react';
import './show-policy-button.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  showPolicy: boolean;
  onSwitchShowPolicy: () => void;
};

const ShowPolicyButton = ({ onSwitchShowPolicy, showPolicy }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="view-cancellation-policy-btn">
      <span onClick={onSwitchShowPolicy}>
        {showPolicy ? t('BACK_BUTTON_TEXT') : t('VIEW_CANCELLATION_POLICY')}
      </span>
    </div>
  );
};

export default ShowPolicyButton;
